'use client'

import { NextIntlClientProvider } from 'next-intl'
import { ReactNode, use, useEffect, useState } from 'react'

interface ProvidersIntlProps {
  children: ReactNode
  locale: string
  messages: any
}

export function ProvidersIntl({ children, locale, messages }: ProvidersIntlProps) {
  const [currentLocale, setCurrentLocale] = useState(locale)
  const [currentMessages, setCurrentMessages] = useState(messages)

  // Listen for locale changes
  useEffect(() => {
    const checkLocaleChange = () => {
      const cookieLocale = document.cookie
        .split('; ')
        .find(row => row.startsWith('NEXT_LOCALE='))
        ?.split('=')[1]

      if (cookieLocale && cookieLocale !== currentLocale) {
        setCurrentLocale(cookieLocale)
        // Load new messages
        import(`../messages/${cookieLocale}.json`).then((msgs) => {
          setCurrentMessages(msgs.default)
        })
      }
    }

    // Check every second for locale changes
    const interval = setInterval(checkLocaleChange, 1000)
    return () => clearInterval(interval)
  }, [currentLocale])

  return (
    <NextIntlClientProvider locale={currentLocale} messages={currentMessages}>
      {children}
    </NextIntlClientProvider>
  )
}
